export default "__VITE_ASSET__DpEWOGbN__"